import { guardArray } from "../array";
import type { AcknowledgementDefinitionsList, Nullable } from "../types";

/**
 * The required acknowledgement definitions the user has not ticked.
 *
 * @param definitions - The definitions required for the worksite, as the requirements returned them.
 * @param acknowledgedDefinitionIds - The definition ids the user ticked.
 * @returns The ids of the definitions still missing, in the order the definitions arrived.
 */
export function getMissingAcknowledgementDefinitionIds(
	definitions: Nullable<AcknowledgementDefinitionsList>,
	acknowledgedDefinitionIds: Nullable<string[]>,
): string[] {
	const acknowledged = new Set(guardArray(acknowledgedDefinitionIds));
	return guardArray(definitions)
		.map((definition) => definition.id)
		.filter((id) => !acknowledged.has(id));
}
